// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Pw8l","selected":"styles_selected__PQsh6"};